import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { ContainerBase } from './containerBase';

// Generic vertical layout
const LeftSidebarLayoutOuter = styled.div<{ $marginLeft: boolean }>`
    margin-left: ${(props) => (props.$marginLeft ? '300px' : 'unset')};
`;

const LeftSidebarLayoutInner = styled(ContainerBase)<{ $maxWidth: boolean; $isMenuHidden: boolean }>`
    max-width: ${(props) => (props.$maxWidth || props.$isMenuHidden ? '100%' : props.theme.size.container)};
    padding-left: ${(props) => (props.$maxWidth && !props.$isMenuHidden ? '295px' : 'unset')};
    padding-right: ${(props) => (props.$maxWidth && !props.$isMenuHidden ? '0px' : 'unset')};
    padding-bottom: var(--left-sidebar-layout-padding-bottom, 55px);
`;

export type SidebarItemIdType = string | number;

export interface SidebarItem<T extends SidebarItemIdType = string> {
    id: T;
    label: string;
    selected?: boolean;
    disabled?: boolean;
    subItems?: SidebarItem<T>[];
    buttons?: SidebarButton[];
    position?: number;
}

export interface SidebarButton {
    key: string;
    tooltip?: string;
    icon: React.ReactElement<React.SVGAttributes<SVGElement>>;
    isActive?: boolean;
    id?: string;
}

interface LeftSidebarLayoutProps {
    sidebar?: React.ReactNode;
    maxWidth?: boolean;
    marginLeft?: boolean;
    isMenuHidden?: boolean;
}

export const LeftSidebarLayout = ({
    children,
    sidebar,
    maxWidth = true,
    marginLeft = false,
    isMenuHidden = false
}: PropsWithChildren<LeftSidebarLayoutProps>) => {
    return (
        <LeftSidebarLayoutOuter $marginLeft={marginLeft}>
            {sidebar}
            <LeftSidebarLayoutInner $maxWidth={maxWidth} $isMenuHidden={isMenuHidden}>
                {children}
            </LeftSidebarLayoutInner>
        </LeftSidebarLayoutOuter>
    );
};
